import { RadioGroup } from 'rsuite';

import { Callout } from '../../../../../../components/Callout';
import { InfoRadio } from '../../../../../../components/InfoRadio';
import styles from '../SetupIpaPriceArchitecture.module.scss';
import { PriceArchitectureFormValues } from '../types';

type PriceArchitecturePsychologicalPricingProps = {
  value: PriceArchitectureFormValues['applyPsychologicalPricing'];
  onChange: (value: PriceArchitectureFormValues['applyPsychologicalPricing']) => void;
};

export const PriceArchitecturePsychologicalPricing = ({ value, onChange }: PriceArchitecturePsychologicalPricingProps) => (
  <section className={styles.psychologicalSection} aria-labelledby="price-architecture-psychological-title">
    <div className={styles.sectionHeader}>
      <h2 id="price-architecture-psychological-title">Preço psicológico na arquitetura</h2>
      <p>Defina se os preços calculados pela arquitetura devem ser arredondados segundo regras de preço psicológico</p>
    </div>

    <RadioGroup
      aria-label="Preço psicológico na arquitetura"
      value={value ? 'apply' : 'do-not-apply'}
      onChange={selectedValue => onChange(selectedValue === 'apply')}
      className={styles.radioGroup}
    >
      <InfoRadio value="apply" className={styles.radioOption}>
        <span className={styles.radioText}>
          <span className={styles.radioTitle}>Aplicar preço psicológico</span>
          <span className={styles.radioDescription}>Os preços sugeridos serão arredondados de acordo com as regras definidas em preço psicológico</span>
        </span>
      </InfoRadio>
      <InfoRadio value="do-not-apply" className={styles.radioOption}>
        <span className={styles.radioText}>
          <span className={styles.radioTitle}>Não aplicar preço psicológico</span>
          <span className={styles.radioDescription}>Os preços sugeridos pela arquitetura serão utilizados sem arredondamento psicológico</span>
        </span>
      </InfoRadio>
    </RadioGroup>

    <Callout variant="info" size="sm" className={styles.architectureCallout}>
      <Callout.Description>
        <span className={styles.architectureCalloutEmphasis}>
          Produtos incluídos em uma arquitetura seguem exclusivamente as regras dela, sendo ignorados pela lógica de Família.
        </span>{' '}
        O produto referência continua sendo precificado pelo motor normalmente e seu preço serve como base para os demais itens. Se parte dos produtos de uma
        Família entrar em uma arquitetura, recomenda-se incluir todos os produtos relacionados para evitar que algum fique sem referência de preço.
      </Callout.Description>
    </Callout>
  </section>
);
